import axios from 'axios';

export default class HttpService {
    baseApiUrl: string = `${process.env.VUE_APP_CPORTAL_URL}${
        process.env.VUE_APP_CPORTAL_PORT && process.env.VUE_APP_CPORTAL_PORT !== ''
            ? ':' + process.env.VUE_APP_CPORTAL_PORT
            : ''
    }${process.env.VUE_APP_CPORTAL_API_PREFIX}`;

    private setHeaders(): { headers } {
        const headersRequest = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        };
        return headersRequest;
    }

    // **********  CLIENT  ********** //

    //TODO WORK VIA ENDPOINT
    async getUser(token: string) {
        return { data: JSON.parse(localStorage.getItem('user_state') || '') };
    }

    async userLookup(user: { username: string }) {
        return axios.post(`${this.baseApiUrl}/lookup`, user);
    }

    async userLogin(user: {}) {
        return axios.post(`${this.baseApiUrl}/authorize`, user, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    setRating(rating: {}) {
        axios
            .post(`${this.baseApiUrl}/feedbacks`, rating, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            .then(response => response)
            .catch(err => err);
    }

    // **********  TICKETS  ********** //
    async getTickets(customerid: number) {
        return axios.get(`${this.baseApiUrl}/views/${customerid}/tickets`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getPaginationTickets(config: { customerid: number; limit: number; start: number }) {
        return axios.get(
            `${this.baseApiUrl}/tickets?customerId=${config.customerid}&limit=${config.limit}&start=${config.start}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async getDataCreateTickets() {
        return axios.get(`${this.baseApiUrl}/views/customers/21347/tickets/generate`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async setTicketRequirement(ticket: {}) {
        return axios.post(`${this.baseApiUrl}/tickets`, ticket, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getDataPDT(pdts: { customerid: number; limit: number; start: number }) {
        return axios.get(
            `${this.baseApiUrl}/tickets/access-permissions?limit=${pdts.limit}&start=${pdts.start}&customerId=${pdts.customerid}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async setTicketAccess(ticket: {}) {
        return axios.post(`${this.baseApiUrl}/tickets`, ticket, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    saveToken() {
        return axios.delete(`${this.baseApiUrl}/tokens/logout`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getFilters() {
        return axios.get(`${this.baseApiUrl}/views/tickets/filters`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getTicketsDayco(tickets: { limit: number; start: number }) {
        return axios.get(
            `${this.baseApiUrl}/tickets?limit=${tickets.limit}&start=${tickets.start}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    getBill(bill: { customerid: string; date: string }) {
        return axios
            .get(`${this.baseApiUrl}/customers/${bill.customerid}/invoices/${bill.date}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                responseType: 'arraybuffer',
            })
            .then(res => {
                return res;
            })
            .catch(e => {
                throw new Error(e);
            });
    }

    uploadMaintenanceReportFile(data: { date: string; formData: any; location: string }) {
        return axios.post(
            `${this.baseApiUrl}/maintenance-reports/${data.location}/${data.date}`,
            data.formData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    uploadFile(data: { customerId: number; fileType: string; date: string; formData: any }) {
        return axios.post(
            `${this.baseApiUrl}/${data.fileType}/${data.customerId}/${data.date}`,
            data.formData,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }
    getAllBills(customer: { customerid: string }) {
        return axios
            .get(`${this.baseApiUrl}/customers/${customer.customerid}/invoices`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            .then(res => {
                return res;
            })
            .catch(e => {
                throw new Error(e);
            });
    }

    getBillByName(file: { name: string }) {
        return axios
            .get(`${this.baseApiUrl}/customers/invoices?fileName=${file.name}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                responseType: 'arraybuffer',
            })
            .then(res => {
                return res;
            })
            .catch(e => {
                throw new Error(e);
            });
    }

    getReport(report: { customerid: string; date: string }) {
        return axios
            .get(`${this.baseApiUrl}/customers/${report.customerid}/reports/${report.date}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                responseType: 'arraybuffer',
            })
            .then(res => {
                return res;
            })
            .catch(e => {
                throw new Error(e);
            });
    }

    async showPDT(data: { ticketid: number }) {
        return axios.get(`${this.baseApiUrl}/tickets/${data.ticketid}/access-permissions`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getTicketsByFilter(tickets: {
        customerid: string;
        limit: number;
        start: number;
        type: string;
        status: string;
        startDate: string;
        endDate: string;
    }) {
        return axios.get(
            `${this.baseApiUrl}/tickets?limit=${tickets.limit}&start=${tickets.start}${tickets.status}${tickets.startDate}${tickets.endDate}${tickets.type}&customerId=${tickets.customerid}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    // **********  PROFILE  ********** //
    async updateUserInfo(info: {}) {
        return axios.post(`${this.baseApiUrl}/tickets`, info, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getFeedback(config: { limit: number; start: number; type: number | null }) {
        if (config.type !== null) {
            return axios.get(
                `${this.baseApiUrl}/views/feedbacks?limit=${config.limit}&start=${config.start}&type=${config.type}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                },
            );
        } else {
            return axios.get(
                `${this.baseApiUrl}/views/feedbacks?limit=${config.limit}&start=${config.start}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                },
            );
        }
    }

    async getInfoReports() {
        return axios.get(`${this.baseApiUrl}/views/reports`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async setInfoReportsDisp(data: {}) {
        return axios.post(`${this.baseApiUrl}/reports`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async setInfoReportsInt(data: {}) {
        return axios.post(`${this.baseApiUrl}/incidents`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getReports() {
        return axios.get(`${this.baseApiUrl}/views/dashboard/reports`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }
    ///reports/equipments/:equipmentId/parameters/:parameterId
    async getBuildingsReports(paramBuilding: { idBuilding: number; idParameter: number }) {
        return axios.get(
            `${this.baseApiUrl}/reports/buildings/${paramBuilding.idBuilding}/parameters/${paramBuilding.idParameter}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async getMensualReport(data: { dataCenter: number; month: number; year: number }) {
        return axios.get(
            `${this.baseApiUrl}/reports/monthlyReport?dataCenterId=${data.dataCenter}&year=${data.year}&month=${data.month}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async getInterruptionReport(data: { dataCenter: number; year: number; summary: number }) {
        if (data.summary == 1) {
            return axios.get(
                `${this.baseApiUrl}/incidents/incident-report?dataCenterId=${data.dataCenter}&year=${data.year}&summary=${data.summary}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                },
            );
        } else {
            return axios.get(
                `${this.baseApiUrl}/incidents/incident-report?dataCenterId=${data.dataCenter}&year=${data.year}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                    },
                },
            );
        }
    }

    async getDirectoryContactsWithAdminInfo(idCustomer: number) {
        return axios.get(`${this.baseApiUrl}/customers/${idCustomer}/admin-users`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getContactUser(contactId: number) {
        return axios.get(`${this.baseApiUrl}/tickets/year-detail?contactId=${contactId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async createContact(contact: {}) {
        return axios.post(`${this.baseApiUrl}/tickets`, contact, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getContact(userId: number) {
        return axios.get(`${this.baseApiUrl}/me/${userId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async updateContact(contact: {}) {
        return axios.post(`${this.baseApiUrl}/tickets`, contact, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async deleteContact(contact: any) {
        return axios.post(`${this.baseApiUrl}/tickets`, contact, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async createUserUpdateContact(contact: any) {
        return axios.post(`${this.baseApiUrl}/tickets`, contact, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getCustomerRolesStatusesResourcesPrivileges(customerId: number) {
        return axios.get(`${this.baseApiUrl}/views/customers/${customerId}/contacts/generate`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async createRol(rol: {}) {
        return axios.post(`${this.baseApiUrl}/roles`, rol, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async updateRol(rol: {
        id: number;
        name: string;
        description: string;
        privileges: {
            privilege: {
                id: number;
            };
        }[];
    }) {
        return axios.patch(`${this.baseApiUrl}/roles/${rol.id}`, rol, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async deleteRol(rol: { customerId: number; rolId: number }) {
        return axios.delete(
            `${this.baseApiUrl}/roles?customerId=${rol.customerId}&roleId=${rol.rolId}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async getUsersWithRol(rol: { customerId: number; rolId: number }) {
        return axios.get(
            `${this.baseApiUrl}/customers/${rol.customerId}/contacts/roles/${rol.rolId}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async validateUsername(user: { customerId: number; username: string }) {
        return axios.get(`${this.baseApiUrl}/customers/${user.customerId}/users/${user.username}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async createUser(user: {
        username: string;
        password: string;
        customerRole: number;
        contactId: number;
        customerId: number;
        status: number;
    }) {
        return axios.post(`${this.baseApiUrl}/users`, user, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async updateUser(user: {
        id: number;
        username: string;
        customerRole: number;
        contactId: number;
        customerId: number;
        status: number;
    }) {
        return axios.patch(`${this.baseApiUrl}/users`, user, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getCustomers(customersOptions: { limit: number; start: number; keyword: string }) {
        return axios.get(
            `${this.baseApiUrl}/customers?limit=${customersOptions.limit}&start=${customersOptions.start}&keyword=${customersOptions.keyword}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async getEquipments(equipmentsOptions: {
        limit: number;
        start: number;
        dataCenter: number | null;
        building: number | null;
        keyword: string;
    }) {
        let dataCenterOption: string = equipmentsOptions.dataCenter
            ? `&dataCenterId=${equipmentsOptions.dataCenter}`
            : '';
        let buildingOption: string = equipmentsOptions.building
            ? `&buildingId=${equipmentsOptions.building}`
            : '';
        let keywordOption: string = equipmentsOptions.keyword
            ? `&keyword=${equipmentsOptions.keyword}`
            : '';

        return axios.get(
            `${this.baseApiUrl}/equipments?limit=${equipmentsOptions.limit}&start=${equipmentsOptions.start}${dataCenterOption}${buildingOption}${keywordOption}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async getDataCentersAndBuildings() {
        return axios.get(`${this.baseApiUrl}/reports/data-centers`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getParameters() {
        return axios.get(`${this.baseApiUrl}/equipments/parameters`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async createEquipment(equipmnet: {
        name: string;
        buildingDataCenters: {
            id: number;
            parameters: number[];
        }[];
    }) {
        return axios.post(`${this.baseApiUrl}/equipments`, equipmnet, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async updateEquipment(equipmnet: {
        id: number;
        name: string;
        buildingDataCenters: {
            id: number;
            parameters: number[];
        }[];
    }) {
        return axios.patch(`${this.baseApiUrl}/equipments`, equipmnet, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async deleteEquipment(buildingEquipmentId: number) {
        return axios.delete(
            `${this.baseApiUrl}/equipments?buildingEquipmentId=${buildingEquipmentId}`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            },
        );
    }

    async sendEmailForPasswordRecovery(data: { username: string; customer: number | null }) {
        return axios.post(`${this.baseApiUrl}/forgot-password`, data, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async resetPassword(data: {
        token: string;
        dataToSend: {
            id: number;
            username: string;
            customerId: number | null;
            password: string;
        };
    }) {
        return axios.post(
            `${this.baseApiUrl}/reset-password?reset_token=${data.token}`,
            data.dataToSend,
            {
                headers: { Authorization: `Bearer ${data.token}` },
            },
        );
    }

    async getCustomerInfo(data: { id: number | null }) {
        return axios.get(`${this.baseApiUrl}/me/${data.id}`);
    }

    async getDaycoRoles() {
        return axios.get(`${this.baseApiUrl}/roles/dayco-roles`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async getDaycoGroups(mapped: boolean) {
        let mappedOption: string = mapped ? `?mapped=${mapped}` : '';
        return axios.get(`${this.baseApiUrl}/roles/ad-groups${mappedOption}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async mapDaycoRolAndGroup(mapped: { name: string; customerRole: any }) {
        return axios.post(`${this.baseApiUrl}/roles/ad-groups`, mapped, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async updateMappingDaycoRolAndGroup(mapped: { id: number; name: string; customerRole: any }) {
        return axios.patch(`${this.baseApiUrl}/roles/ad-groups`, mapped, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }

    async deleteDaycoGroup(groupId: number) {
        return axios.delete(`${this.baseApiUrl}/roles/ad-groups/${groupId}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
    }
}
